import { useCallback, useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { requiresSubscription } from '../utils/subscriptionGate';

export default function useSubscriptionGate() {
	const { subscription, activeFitnessProfile, openPricingModal } = useAuth();

	const isSubscriptionRequired = useMemo(
		() => requiresSubscription({ subscription, activeFitnessProfile }),
		[subscription, activeFitnessProfile]
	);

	const guardSubscription = useCallback(
		(action) => {
			if (!isSubscriptionRequired) {
				if (action) action();
				return true;
			}

			openPricingModal();
			return false;
		},
		[isSubscriptionRequired, openPricingModal]
	);

	return {
		isSubscriptionRequired,
		guardSubscription,
		openPricingModal
	};
}
